module.exports = __webpack_public_path__ + "img/logo_big_trazo.1e793516.png";